import gql from 'graphql-tag';

const UPDATE_STUDENT_SETTING_FRAGMENT = gql`
  fragment UpdateStudentSettingFragment on BaseStudentSettingResponse {
    student {
      id
    }
    app {
      id
    }
    setting
    value
  }
`;

export default UPDATE_STUDENT_SETTING_FRAGMENT;
